import { jsxs as e, Fragment as o, jsx as n } from "react/jsx-runtime";
import { Link as i } from "@mui/material";
const r = {
  title: {
    en: "Cookies",
    es: "Cookies",
    "zh-Hans": "Cookies"
  },
  description: {
    en: /* @__PURE__ */ e(o, { children: [
      "We use cookies. Some are necessary to make our site work and others are optional, allowing us to analyse site usage and personalize content. You can change your preferences by clicking 'Manage Cookies'. To find out more about the cookies we use, see our",
      " ",
      /* @__PURE__ */ n(
        i,
        {
          href: "https://stenn.com/privacy-policy",
          target: "_blank",
          underline: "hover",
          children: "Privacy and Cookie Policy"
        }
      ),
      "."
    ] }),
    es: /* @__PURE__ */ e(o, { children: [
      "Utilizamos cookies. Algunas son necesarias para que nuestro sitio funcione y otras son opcionales, lo que nos permite analizar el uso del sitio y personalizar el contenido. Puede cambiar sus preferencias haciendo clic en 'Administrar Cookies'. Para obtener más información sobre las cookies que utilizamos, consulte nuestra",
      " ",
      /* @__PURE__ */ n(
        i,
        {
          href: "https://stenn.com/es/privacy-policy",
          target: "_blank",
          underline: "hover",
          children: "Política de privacidad y cookies"
        }
      ),
      "."
    ] }),
    "zh-Hans": /* @__PURE__ */ e(o, { children: [
      "我们使用 cookie。一些是必要的，用于使我们的网站正常运行，另一些是可选的，使我们能够分析网站使用情况并个性化内容。您可以通过单击“管理Cookie”来更改您的偏好。要了解更多关于我们使用的 cookie，请参阅我们的",
      " ",
      /* @__PURE__ */ n(
        i,
        {
          href: "https://stenn.com/zh/privacy-policy",
          target: "_blank",
          underline: "hover",
          children: "隐私和Cookie政策"
        }
      ),
      "。"
    ] })
  },
  acceptAllButton: {
    en: "Accept all",
    es: "Aceptar todo",
    "zh-Hans": "拒绝全部"
  },
  rejectAllButton: {
    en: "Reject all",
    es: "Rechazar todo",
    "zh-Hans": "拒绝全部"
  },
  manageCookiesButton: {
    en: "Manage cookies",
    es: "Administrar cookies",
    "zh-Hans": "管理 cookie"
  }
};
export {
  r as messages
};
//# sourceMappingURL=messages2.mjs.map
